<template>
    <div id="GeoChooser" :key="key">
        <b-container>
            <b-row cols=12 align-v="center" align-h="center" style="padding-top: 6px">
                <b-col cols="3" v-if="vCard.txt">
                    <b-row cols="12" style="padding-top: 6px">

                        <b-col cols="12" lg="8">
                            <div v-if="vCard.txt" @click.prevent.stop="showVCard()">
                                <a href="#"><b-img thumbnail fluid :src="imgUrl" center></b-img></a>
                            </div>
                        </b-col>

                    </b-row>
                </b-col>

                <b-col>
                    <b-row cols="9" align-h="center">
                        <b-col lg="3">
                            <div class="tbl1Name text-center">
                                <b-link @click="chCountry()"><h5 class="txtShad">{{ $t('COUNTRY') }}</h5></b-link>
                            </div>
                            <b-form-select
                            v-if="intLoc=='ru'"
                            v-model="selCountryRu"
                            :options="optCountryRu"
                            @change="chCountry()"
                            >
                            </b-form-select>
                            <b-form-select
                            v-else
                            v-model="selCountryEn"
                            :options="optCountryEn"
                            @change="chCountry()"
                            >
                            </b-form-select>
                        </b-col>
                        <b-col lg="3">
                            <div v-if="optDistrictRu[0].text">
                                <div class="tbl1Name text-center">
                                    <b-link @click="chDistrict()"><h5 class="txtShad">{{ $t('DISTRICT') }}</h5></b-link>
                                </div>
                                <b-form-select
                                v-if="intLoc=='ru'"
                                v-model="selDistrictRu"
                                :options="optDistrictRu"
                                @change="chDistrict()"
                                >
                                </b-form-select>
                                <b-form-select
                                v-else
                                v-model="selDistrictEn"
                                :options="optDistrictEn"
                                @change="chDistrict()"
                                >
                                </b-form-select>
                            </div>
                        </b-col>
                        <b-col lg="3">
                            <div v-if="optCityRu[0].text">
                                <div class="tbl1Name text-center">
                                    <b-link @click="chCity()"><h5 class="txtShad">{{ $t('CITY') }}</h5></b-link>
                                </div>
                                <b-form-select
                                v-if="intLoc=='ru'"
                                v-model="selCityRu"
                                :options="optCityRu"
                                @change="chCity()"
                                >
                                </b-form-select>
                                <b-form-select
                                v-else
                                v-model="selCityEn"
                                :options="optCityEn"
                                @change="chCity()"
                                >
                                </b-form-select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row align-h="center" style="padding-top: 6px">
                        <b-col lg="3">
                            <div v-if="optEnsembleRu[0].text">
                                <div class="tbl1Name text-center">
                                    <b-link @click="chEnsemble()"><h5 class="txtShad">{{ $t('ENSEMBLE') }}</h5></b-link>
                                </div>
                                <b-form-select
                                v-if="intLoc=='ru'"
                                v-model="selEnsembleRu"
                                :options="optEnsembleRu"
                                @change="chEnsemble()"
                                >
                                </b-form-select>
                                <b-form-select
                                v-else
                                v-model="selEnsembleEn"
                                :options="optEnsembleEn"
                                @change="chEnsemble()"
                                >
                                </b-form-select>
                            </div>
                        </b-col>
                        <b-col lg="3">
                            <div v-if="optSightRu[0].text">
                                <div class="tbl1Name text-center">
                                    <b-link @click="chSight()"><h5 class="txtShad">{{ $t('SIGHT') }}</h5></b-link>
                                </div>
                                <b-form-select
                                v-if="intLoc=='ru'"
                                v-model="selSightRu"
                                :options="optSightRu"
                                @change="chSight()"
                                >
                                </b-form-select>
                                <b-form-select
                                v-else
                                v-model="selSightEn"
                                :options="optSightEn"
                                @change="chSight()"
                                >
                                </b-form-select>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
<!--
                <b-col>
                    <b-button class="m-1" style="padding-top: 6px">
                                <span  v-b-popover.hover.top="this.$t('CLEAR')" @click="clear()">
                                    <font-awesome-icon icon="broom" size="lg"/>
                                </span>
                    </b-button>
                </b-col>
-->
            </b-row>

        </b-container>

        <br>
        <b-container fluid class="footer text-center">
            <b-row>
                <b-col>
                    <b-form-radio-group id="radio-group-2" name="radio-sub-component">
                        <b-button class="m-1" @click="retToParent()" v-if="retOnce">Ok</b-button>
                        <b-button class="m-1" @click="close()" v-if="retOnce">{{$t('CLOSE')}}
                        </b-button>
                    </b-form-radio-group>
                </b-col>
            </b-row>
        </b-container>

        <b-modal
                size="xl"
                id="vCard"
                :img-alt="vCard.txt"
                header-bg-variant="secondary"
                header-text-variant="light"
                body-bg-variant="secondary"
                hide-footer
        >
            <template #modal-header>
                {{vCard.txt}}
                <b-button size="sm" variant="light" @click="$bvModal.hide('vCard')">
                    х
                </b-button>
            </template>
            <b-img :src="imgUrl" center alt="vCard.txt"></b-img>
            <b-link :href="vCard.link" rel="nofollow" class=".mr-5" style="color:white">{{vCard.attr}}</b-link>
        </b-modal>

    </div>
</template>

<script>
import { BContainer, BRow, BCol, BButton, BFormSelect, BFormRadioGroup, BImg, BLink, BModal } from 'bootstrap-vue';

export default {
  name: 'GeoChooser',
  components: {
    BContainer, BRow, BCol, BButton, BFormSelect, BFormRadioGroup, BImg, BLink, BModal
  },
  props: {
    chooserName: String,
    scope: String,
    retOnce: Boolean
  },
  data: function() {
    return {
        key: 0,
        userName: '',
        curUserName: '',
        company: {},
        itemName: '',
        itemType: '',
        countryRu: '',
        countryEn: '',
        districtRu: '',
        districtEn: '',
        cityRu: '',
        cityEn: '',
        ensembleRu: '',
        ensembleEn: '',
        sightRu: '',
        sightEn: '',
        selCountryRu: '',
        selCountryEn: '',
        optCountryRu: [{}],
        optCountryEn: [{}],
        selDistrictRu: '',
        selDistrictEn: '',
        optDistrictRu: [{}],
        optDistrictEn: [{}],
        selCityRu: '',
        selCityEn: '',
        optCityRu: [{}],
        optCityEn: [{}],
        selEnsembleRu: '',
        selEnsembleEn: '',
        optEnsembleRu: [{}],
        optEnsembleEn: [{}],
        selSightRu: '',
        selSightEn: '',
        optSightRu: [{}],
        optSightEn: [{}],
        sure: null,
        refType: null,
        intLoc: this.$i18n.locale,
        item: '',
        geoType: '',
        chsnGeo: '',
        untieGeo: false,
        modalShow: false,
        init: false,
        imgUrl: '',
        vCard: {}
    }
  },
  mounted() {
    this.curUserName = this.$store.state.curUserName;
    this.getCountries();
    //alert(this.retOnce);
  },
  methods: {
    async getCountries() {
        this.chsnGeo = 'country';
        let action = this.scope === 'all' ? '/getAllCountries' : '/getCountries'
        try {
            const response = await this.$http.get(action, {
                params: {
                    resType: this.scope,
                    intLoc: this.intLoc
                }
            });
            this.optCountryRu = response.data.optRefsRu;
            this.optCountryEn = response.data.optRefsEn;
            this.clearDistricts();
            this.clearCities();
            this.clearEnsembles();
            this.clearSights();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getDistricts() {
        this.chsnGeo = 'district';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.optDistrictRu = [{}],
        this.optDistrictEn = [{}],
        this.optCityRu = [{}],
        this.optCityEn = [{}],
        this.itemsC = [{}];
        let action = this.scope === 'all' ? '/getAllDistricts' : '/getDistricts'
        try {
            const response = await this.$http.get(action, {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    resType: this.scope,
                    intLoc: this.intLoc
                }
            });
            if(typeof response.data == 'undefined' || response.data == '') return;
            this.optDistrictRu = response.data.optRefsRu;
            this.optDistrictEn = response.data.optRefsEn;
            this.clearCities();
            this.clearEnsembles();
            this.clearSights();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getCities() {
        this.chsnGeo = 'city';
        let action = this.scope === 'all' ? '/getAllCities' : '/getCities'
        try {
            const response = await this.$http.get(action, {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    resType: this.scope,
                    intLoc: this.intLoc
                }
            });
            if(typeof response.data == 'undefined' || response.data == '') return;
            this.optCityRu = response.data.optRefsRu;
            this.optCityEn = response.data.optRefsEn;
            this.clearEnsembles();
            this.clearSights();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getEnsembles() {
        this.chsnGeo = 'ensemble';
        let action = this.scope === 'all' ? '/getAllEnsembles' : '/getEnsembles'
        try {
            const response = await this.$http.get(action, {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    resType: this.scope,
                    intLoc: this.intLoc
                }
            });
            if(typeof response.data == 'undefined' || response.data == '') return;
            this.optEnsembleRu = response.data.optRefsRu;
            this.optEnsembleEn = response.data.optRefsEn;
            this.clearSights();
            this.scope = 'all';
            this.getSights();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getEnsemble() {
        //this.chsnGeo = 'ensemble';
        //let action = this.scope === 'all' ? '/getAllEnsembles' : '/getEnsembles'
            this.scope = 'offers';
        //alert(this.sightRu+" "+this.sightEn);
        try {
            const response = await this.$http.get('/getEnsemble', {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    sightRu: this.sightRu,
                    sightEn: this.sightEn,
                    resType: this.scope,
                    intLoc: this.intLoc
                }
            });
            if(typeof response.data == 'undefined' || response.data == '') return;
            this.optEnsembleRu = response.data.optRefsRu;
            this.optEnsembleEn = response.data.optRefsEn;
            //this.clearSights();
            //this.getSights();


        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },



    async getSights() {
        this.chsnGeo = 'sight';
        let action = this.scope === 'all' ? '/getAllSights' : '/getSights'
        try {
            const response = await this.$http.get(action, {
            //    const response = await this.$http.get('/getAllSights', {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    ensembleRu: this.ensembleRu,
                    ensembleEn: this.ensembleEn,
                    resType: this.scope,
                    intLoc: this.intLoc
                }
            });
            if(typeof response.data == 'undefined' || response.data == '') return;
            this.optSightRu = response.data.optRefsRu;
            this.optSightEn = response.data.optRefsEn;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    chCountry() {
        if(this.intLoc==='ru') {
            this.countryRu = this.optCountryRu[this.selCountryRu].text;
            this.countryEn = this.optCountryEn[this.selCountryRu].text;
            this.selCountryEn = this.optCountryEn[this.selCountryRu].value;
        } else {
            this.countryEn = this.optCountryEn[this.selCountryEn].text;
            this.countryRu = this.optCountryRu[this.selCountryEn].text;
            this.selCountryRu = this.optCountryRu[this.selCountryEn].value;
        }
        this.clearDistricts();
        this.clearCities();
        this.clearEnsembles();
        this.clearSights();
        this.geoType = 'country';
        this.getDistricts();
        if(!this.retOnce) this.retToParent()
    },
    chDistrict() {
        if(this.intLoc==='ru') {
            this.districtRu = this.optDistrictRu[this.selDistrictRu].text;
            this.districtEn = this.optDistrictEn[this.selDistrictRu].text;
            this.selDistrictEn = this.optDistrictEn[this.selDistrictRu].value;
        } else {
            this.districtEn = this.optDistrictEn[this.selDistrictEn].text;
            this.districtRu = this.optDistrictRu[this.selDistrictEn].text;
            this.selCountryRu = this.optDistrictRu[this.selDistrictEn].value;
        }
        this.geoType = 'district';
        this.clearCities();
        this.clearEnsembles();
        this.clearSights();
        this.getCities();
        if(!this.retOnce) this.retToParent()
    },
    chCity() {
        if(this.intLoc==='ru') {
            this.cityRu = this.optCityRu[this.selCityRu].text;
            this.cityEn = this.optCityEn[this.selCityRu].text;
            this.selCityEn = this.optCityEn[this.selCityRu].value;
        } else {
            this.cityEn = this.optCityEn[this.selCityEn].text;
            this.cityRu = this.optCityRu[this.selCityEn].text;
            this.selCityRu = this.optCityRu[this.selCityEn].value;
        }
        this.geoType = 'city';
        this.clearEnsembles();
        this.clearSights();
        this.getEnsembles();
        this.getSights();
        if(!this.retOnce) this.retToParent()
    },
    chEnsemble() {
        this.SightRu = '';
        this.SightEn = '';
        if(this.intLoc==='ru') {
            this.ensembleRu = this.optEnsembleRu[this.selEnsembleRu].text;
            this.ensembleEn = this.optEnsembleEn[this.selEnsembleRu].text;
            this.selEnsembleEn = this.optEnsembleEn[this.selEnsembleRu].value;
        } else {
            this.ensembleEn = this.optEnsembleEn[this.selEnsembleEn].text;
            this.ensembleRu = this.optEnsembleRu[this.selEnsembleEn].text;
            this.selEnsembleRu = this.optEnsembleRu[this.selEnsembleEn].value;
        }
        this.geoType = 'ensemble';
        this.clearSights();
        this.getSights();
        if(!this.retOnce) this.retToParent()
    },
    chSight() {
        if(this.intLoc==='ru') {
            this.sightRu = this.optSightRu[this.selSightRu].text;
            this.sightEn = this.optSightEn[this.selSightRu].text;
            this.selSightEn = this.optSightEn[this.selSightRu].value;
        } else {
            this.sightEn = this.optSightEn[this.selSightEn].text;
            this.sightRu = this.optSightRu[this.selSightEn].text;
            this.selSightRu = this.optSightRu[this.selSightEn].value;
        }
        this.getEnsemble();
        //this.geoType = 'sight';
        //if(!this.retOnce) this.retToParent()
    },
    chListLoc(newListLoc) {
        this.intLoc = newListLoc;
        this.curPageC = 1;
        this.selCountryRu = 'Россия';
        this.selCountryEn = 'Russia';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.selEnsembleRu = '';
        this.selEnsembleEn = '';
        this.selSightRu = '';
        this.selSightEn = '';
        this.itemsC = [];
    },
    clearDistricts() {
        this.districtRu = '';
        this.districtEn = '';
        this.selDistrictRu = '';
        this.optDistrictRu = [{}];
        this.selDistrictEn = '';
        this.optDistrictEn = [{}];
    },
    clearCities() {
        this.cityRu = '';
        this.cityEn = '';
        this.selCityRu = '';
        this.optCityRu = [{}];
        this.selCityEn = '';
        this.optCityEn = [{}];
    },
    clearEnsembles() {
        this.ensembleRu = '';
        this.ensembleEn = '';
        this.selEnsembleRu = '';
        this.optEnsembleRu = [{}];
        this.selEnsembleEn = '';
        this.optEnsembleEn = [{}];
    },
    clearSights() {
        this.sightRu = '';
        this.sightEn = '';
        this.selSightRu = '';
        this.optSightRu = [{}];
        this.selSightEn = '';
        this.optSightEn = [{}];
    },
    clear() {
        this.key++;
        this.geoType = '';
        this.countryRu = '';
        this.countryEn = '';
        this.districtRu = '';
        this.districtEn = '';
        this.cityRu = '';
        this.cityEn = '';
        this.ensembleRu = '';
        this.ensembleEn = '';
        this.sightRu = '';
        this.sightEn = '';
        this.selCountryRu = '';
        this.selCountryEn = '';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.selEnsembleRu = '';
        this.selEnsembleEn = '';
        this.selSightRu = '';
        this.selSightEn = '';
        this.optCountryRu = [{}],
        this.optCountryEn = [{}],
        this.optDistrictRu = [{}],
        this.optDistrictEn = [{}],
        this.optCityRu = [{}],
        this.optCityEn = [{}],
        this.optEnsembleRu = [{}],
        this.optEnsembleEn = [{}],
        this.optSightRu = [{}],
        this.optSightEn = [{}],
        this.getCountries();
        this.init = true;
        this.retToParent();
    },
    async getVCardInfo() {
        try {
            const response = await this.$http.get('/getVCardInfo', {
                params: {
                    countryEn: this.countryEn,
                    districtEn: this.districtEn,
                    cityEn: this.cityEn,
                    ensembleEn: this.ensembleEn,
                    sightEn: this.sightEn,
                    intLoc: this.intLoc
                }
            });
            this.vCard = response.data;
            //this.$showMsg(this.vCard.txt);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    getChosenGeo() {
        return {
            "countryRu" : this.countryRu, "countryEn" : this.countryEn,
            "districtRu" : this.districtRu, "districtEn" : this.districtEn,
            "cityRu" : this.cityRu, "cityEn" : this.cityEn,
            "ensembleRu" : this.ensembleRu, "ensembleEn" : this.ensembleEn,
            "sightRu" : this.sightRu, "sightEn" : this.sightEn,
            "init": this.init, "chooserName": this.chooserName
        }
    },
    retToParent() {
        if(this.chooserName === '')
            this.$emit('retFromGeoChooser');
        else if(this.chooserName === 'whereTo')
            this.$emit('getGeoTo');
        else this.$emit('getGeoFrom');
    },
    close() {
        this.countryRu = '';
        this.countryEn = '';
        this.districtRu = '';
        this.districtEn = '';
        this.cityRu = '';
        this.cityEn = '';
        this.ensembleRu = '';
        this.ensembleEn = '';
        this.sightRu = '';
        this.sightEn = '';
        this.retToParent();
    },
    showVCard() {
        if(!this.vCard.txt) return;
        this.$bvModal.show('vCard')
    },
/*
    clearVCard() {
        this.vCard.txt = "";
        this.vCard.attr = "";
        this.vCard.link = "";
        this.imgUrl = "";
    }
*/
  },

  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.key++;
        this.clear();
        //this.getCountries();
    },
    countryEn: function() {
        //this.clearVCard();
        this.getVCardInfo();
        this.imgUrl='data/vCards/'+this.$addEncHyp(this.countryEn+'.jpg');
    },
    districtEn: function() {
        if(!this.districtEn) return;
        //this.clearVCard();
        this.getVCardInfo();
        this.imgUrl='data/vCards/'+this.$addEncHyp(this.countryEn)+'/'+this.$addEncHyp(this.districtEn)+'.jpg';
    },
    cityEn: function() {
        if(!this.cityEn) return;
        //this.clearVCard();
        this.getVCardInfo();
        this.imgUrl='data/vCards/'+this.$addEncHyp(this.countryEn)+'/'+this.$addEncHyp(this.districtEn)+'/'+this.$addEncHyp(this.cityEn)+'.jpg';
    },
    ensembleEn: function() {
        if(!this.ensembleEn) return;
        //this.clearVCard();
        this.getVCardInfo();
        this.imgUrl='data/vCards/'+this.$addEncHyp(this.countryEn)+'/'+this.$addEncHyp(this.districtEn)
        +'/'+this.$addEncHyp(this.cityEn)+'/'+this.$addEncHyp(this.ensembleEn)+'.jpg';
    },
    sightEn: function() {
        if(!this.sightEn) return;
        //this.clearVCard();
        this.getVCardInfo();
        this.imgUrl='data/vCards/'+this.$addEncHyp(this.countryEn)+'/'+this.$addEncHyp(this.districtEn)
        + '/'+this.$addEncHyp(this.cityEn)+'/'
        + (this.ensembleEn ? this.$addEncHyp(this.ensembleEn)+'/' : '')
        + this.$addEncHyp(this.sightEn)+'.jpg';
    }
  }
}

</script>

<style>
.footer
{color:white}

</style>